import { createFileRoute } from "@tanstack/react-router";
import CsrPartnershipPage from "@project/user/pages/csr/index";

export const Route = createFileRoute("/_user/csr-partnership")({
  head: () => ({
    meta: [
      { title: "CSR Partnership — Jivandhara" },
      {
        name: "description",
        content:
          "Partner with Jivandhara for social impact. View our MCA CSR registration certificates and send a CSR partnership enquiry.",
      },
      { property: "og:title", content: "CSR Partnership — Jivandhara" },
    ],
  }),
  component: CsrPartnershipPage,
});
